import { useLazyQuery } from '@vue/apollo-composable'
import { queryOtherPosPageList } from '@/graphql/holdings'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'
import storage, { StorageType } from '@/utils/storage'

export default function useFundAndBond(params: { exchangeType: string }) {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(queryOtherPosPageList)

  onResult((res) => {
    const { otherPosPageList } = res.data
    if (otherPosPageList.ok) {
      if (params.exchangeType === 'FUND') {
        store.commit(HoldingsMutationTypes.SET_FUND_POS_PAGE_LIST, otherPosPageList.data)
      } else {
        store.commit(HoldingsMutationTypes.SET_BOND_POS_PAGE_LIST, otherPosPageList.data)
      }
    }
  })

  const queryFundAndBondData = () => {
    const param = {
      exchangeType: params.exchangeType,
      fundAccount: storage.rcGetItem(StorageType.local, 'userInfo')
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(queryOtherPosPageList, { filter: param }) || refetch({ filter: param })
  }
  return { queryFundAndBondData, onResult, loading }
}
